export default __webpack_public_path__ + "static/media/bp_stage_2.dee763a0.svg";